import React, { useState, useEffect, useRef } from "react";
import Konva from "konva";
import { Group, Text } from "react-konva";
import { useTranslation } from "react-i18next";
import BrandColors from "../../../../../../styles/BrandColors";

const ConnectorPoint = (props) => {
  const { record = {}, onClick } = props;

  const { JLLBrandColors } = BrandColors;
  const { Red, Steel } = JLLBrandColors;

  const expandIconRef = useRef();

  const [expandText, setExpandText] = useState();
  const [expandIcon, setExpandIcon] = useState();

  const [textPosition, setTextPosition] = useState({ x: 0, y: 0 });
  const [iconPosition, setIconPosition] = useState({ x: 0, y: 0 });

  const { t } = useTranslation();

  useEffect(() => {
    if (record.x) {
      setTextPosition({
        x: expandIcon ? record.x + record.width / 2 + 10 : record.x,
        y: record.y - 13
      });
      setIconPosition({
        x: record.x + record.width / 2 - 7,
        y: record.y - 13
      });
    }
  }, [record, expandIcon]);

  useEffect(() => {
    if (!expandIconRef.current) {
      return;
    }

    if (!record.isLoading) {
      expandIconRef.current.opacity(1);
      return;
    }

    var period = 300;

    var anim = new Konva.Animation(frame => {
      if (expandIconRef.current) {
        expandIconRef.current.opacity((Math.sin(frame.time / period) + 1) / 2);
      }
    }, expandIconRef.current.getLayer());

    anim.start();
    return () => {
      anim.stop();
    };
  }, [record.isLoading]);

  useEffect(() => {
    const expandText = record.isLoading ? t("labels.common.loading") :
      record.showParents ?
        !record.hasParents ?
        t("labels.record.ownershipStructure.noParents") : null
        : t("labels.record.ownershipStructure.showParents");
    const expandIcon = record.isLoading ? null :
      record.showParents ?
        !record.hasParents ?
          null : "\uf32d"
        : "\uf331";
    setExpandText(expandText);
    setExpandIcon(expandIcon);
  }, [record.isLoading, record.showParents, record.hasParents]);

  return (
    <Group ref={expandIconRef}>
      <Text
        x={textPosition.x}
        y={textPosition.y}
        fontSize={13}
        width={expandIcon ? record.width / 2 : record.width}
        fontFamily={"Source Sans Pro,sans-serif"}
        align={expandIcon ? "left" : "center"}
        fill={Steel.tint50Percent}
        text={expandText}
        onMouseUp={onClick}
        onMouseEnter={(e) => {
          e.target.getStage().container().style.cursor = 'pointer';
        }}
        onMouseLeave={(e) => {
          e.target.getStage().container().style.cursor = 'default';
        }}
      />
      <Text
        x={iconPosition.x}
        y={iconPosition.y}
        fontSize={14}
        fontFamily={"Font Awesome 5 Pro"}
        fill={Red.core}
        text={expandIcon}
        onMouseUp={onClick}
        onMouseEnter={(e) => {
          e.target.getStage().container().style.cursor = 'pointer';
        }}
        onMouseLeave={(e) => {
          e.target.getStage().container().style.cursor = 'default';
        }}
      />
    </Group>
  )
};

export default ConnectorPoint;